"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSubmissionClientModel = exports.OrderCountListClientModel = exports.OrderCountClientModel = void 0;
var utils_1 = require("../../utils");
var OrderCountClientModel = /** @class */ (function () {
    function OrderCountClientModel(serverModel) {
        this.displayName = utils_1.replaceALl(serverModel.status.name, '_', ' ');
        this.countOrders = serverModel.total;
        this.name = serverModel.status.name;
    }
    return OrderCountClientModel;
}());
exports.OrderCountClientModel = OrderCountClientModel;
var OrderCountListClientModel = /** @class */ (function () {
    function OrderCountListClientModel(serverModel) {
        var total = 0;
        this.stats = serverModel.data.order_count_lists.map(function (orderCount) {
            total += orderCount.total;
            return new OrderCountClientModel(orderCount);
        });
        this.total = total;
    }
    return OrderCountListClientModel;
}());
exports.OrderCountListClientModel = OrderCountListClientModel;
var OrderSubmissionClientModel = /** @class */ (function () {
    function OrderSubmissionClientModel(serverModel) {
        this.response_log = JSON.parse(serverModel.response_log);
    }
    return OrderSubmissionClientModel;
}());
exports.OrderSubmissionClientModel = OrderSubmissionClientModel;
